import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'cityads-v3/types/reducer';
import classes from './Profile.scss';

import AvatarWithFallback from 'cityads-v3/components/ImgWithFallback/AvatarWithFallback'
import Button from '@mui/material/Button';
import Card from 'cityads-v3/components/Card/Card';
import EmptyResults from 'cityads-v3/components/EmptyResults/EmptyResults'
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import SupportButton from 'cityads-v3/components/Buttons/SupportButton';
import Typography from '@mui/material/Typography';

import noavatar from 'cityads-v3/components/Header/img/noavatar.png';

type ManagerProps = {
  onSupportClick?: React.MouseEventHandler
}

export default function Manager({
  onSupportClick
}: ManagerProps): JSX.Element {
  const { t } = useTranslation(['main'])
  const manager = useSelector((state: RootState) => state.header.manager);

  if (!manager) {
    return (
      <EmptyResults
        className={classes.pageContainer}
        icon={<HeadsetMicOutlinedIcon />}
        emptyText={t('haveQuestion')}
        actions={
          <Button
            variant="contained"
            color="primary"
            component={SupportButton}
            onClick={onSupportClick}
          >{t('header.helpdesk')}</Button>
        }
      />
    );
  }

  const actions = [{
    title: t('support'),
    icon: <HeadsetMicOutlinedIcon />,
    color: 'primary',
    isPrimary: true,
    component: SupportButton,
    onClick: onSupportClick,
    target: '_blank',
    rel: 'noopener noreferrer',
    iconStyle: {
      fontSize: '20px',
      verticalAlign: 'middle',
      marginLeft: '8px'
    }
  }];

  return (
    <Card
      classes={{ root: classes.pageContainer }}
      subActions={actions}
    >
      <div className={classes.manager}>
        <div>
          <AvatarWithFallback
            src={manager.avatar}
            fallbackSrc={noavatar}
            classes={{
              root: classes.managerAvatar
            }}
          />
        </div>
        <Typography>{manager.name}</Typography>
        <Typography><a href={`mailto:${manager.email}`}>{manager.email}</a></Typography>
      </div>
    </Card>
  );
}
